import { Link } from "react-router-dom";
import { useSeo } from "../lib/useSeo";

export default function NotFound() {
  useSeo("Page Not Found");
  return (
    <section className="mx-auto max-w-[1400px] px-6 pb-40 pt-48 md:px-10">
      <p className="eyebrow text-wine">404</p>
      <h1 className="mt-6 font-serif text-5xl font-light text-wine md:text-7xl">This page wasn't <span className="italic">meant to be.</span></h1>
      <Link to="/" className="btn btn-primary mt-12" data-testid="notfound-home-btn">Return Home</Link>
    </section>
  );
}
